import React from 'react';
import PropTypes from 'prop-types';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Typography from '@mui/material/Typography';
import FORM_CHECKBOX_CLASS_NAME from '../../theme/constants/checkbox';

const FormCheckboxControlLabel = ({
  checked,
  onChange,
  label,
  checkboxProps,
  typographyProps,
}) => (
  <FormControlLabel
    control={(
      <Checkbox
        className={FORM_CHECKBOX_CLASS_NAME}
        checked={checked}
        onChange={onChange}
        {...checkboxProps}
        size="small"
        sx={{ p: 0.5, ml: 0.5 }}
      />
    )}
    label={(
      <Typography variant="small_2" {...typographyProps}>
        {label}
      </Typography>
    )}
  />
);

FormCheckboxControlLabel.propTypes = {
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.node.isRequired,
  checkboxProps: PropTypes.shape({}),
  typographyProps: PropTypes.shape({}),
};

FormCheckboxControlLabel.defaultProps = {
  checkboxProps: {},
  typographyProps: {},
};

export default FormCheckboxControlLabel;
